import { EditAltIcon } from 'cokitchen-icons';
import React, { useState } from 'react';
import useBrandChefsContext from 'contexts/brand-chefs.context';
import { formatNumberWithCommas } from 'utils/functions';

const ReviewMealsDetails = () => {
  const { setStep, itemToEdit } = useBrandChefsContext();

  const defaultShowVendorDetails = itemToEdit.reduce((result, _, index) => {
    result[index] = false;
    return result;
  }, {} as Record<string, boolean>);
  const [showVendorDetails, setShowVendorDetails] = useState(defaultShowVendorDetails);

  const toggleShowVendorDetails = (idx: number) => {
    const show = showVendorDetails[idx];
    setShowVendorDetails((vendors) => ({
      ...vendors,
      [idx]: !show
    }));
  };

  return (
    <div>
      <div className='flex justify-between mb-6'>
        <h3 className='text-xl font-semibold'>Review meal</h3>
        <p onClick={() => setStep(1)} className='text-[#E60A2B] text-sm font-medium cursor-pointer'>
          {itemToEdit.length === 1 ? 'Edit' : 'Edit all'}
        </p>
      </div>

      {itemToEdit?.map((vendor, vendorIndex) => (
        <div key={vendorIndex}>
          <div className='bg-[#F7F7F7E5] border-b border-[#EAEBEB] py-3 mx-[-28px] flex justify-between'>
            <div className='flex flex-col gap-1 pl-[28px]'>
              <div className='flex gap-2'>
                <p className='text-[16px] font-semibold '>{vendor.ingredient_name}</p>
              </div>
              <span className='text-gray-9 text-sm'>
                {formatNumberWithCommas(vendor.request_portion)}{' '}
                {Number(vendor.request_portion) === 1 ? 'portion' : 'portions'}
              </span>
            </div>
            <div className='flex gap-2 pr-[28px]'>
              <div
                onClick={() => {
                  setStep(1);
                }}
                className='bg-[#EFF0F0] w-8 h-8 rounded-full flex items-center justify-center cursor-pointer'>
                <EditAltIcon />
              </div>
              <div
                onClick={() => toggleShowVendorDetails(vendorIndex)}
                className='bg-white border border-[#EAEBEB] rounded-[100px] flex items-center justify-center  text-xs font-medium text-[#5E6164] cursor-pointer w-[61px] h-[30px] shadow-sm'>
                {showVendorDetails[vendorIndex] ? 'Hide' : 'Show'}
              </div>
            </div>
          </div>

          {showVendorDetails[vendorIndex] ? (
            <div className='  py-3'>
              {vendor?.items?.length && vendor?.items?.length > 0 ? (
                vendor?.items?.map((item, itemIndex) => (
                  <div
                    key={itemIndex}
                    className='flex justify-start items-center border-b-[0.7px] border-[#EDEDEE] py-3 text-sm font-medium gap-1'>
                    <span className='text-gray-12 font-semibold text-sm'>
                      {' '}
                      {item.ingredient.name}
                    </span>{' '}
                    <span className='text-[#D9D9D9] text-2xl'>•</span>{' '}
                    <span className='text-gray-9 text-sm'>
                      {formatNumberWithCommas(item.quantity * Number(vendor.request_portion))}{' '}
                      {item.ingredient.unit_type}
                    </span>
                  </div>
                ))
              ) : (
                <div>
                  <p className='text-sm font-medium mt-1'>No store items</p>
                </div>
              )}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default ReviewMealsDetails;
